<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="8">
          <GradeClassStudentSelect
            :gradeCol="{ cols: 12, md: 6 }"
            :classCol="{ cols: 12, md: 6 }"
            disableStudentSelect
            @changed="gradeClassChange"
          />
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col cols="12" md="4">
          <AutocompleteSubjectGroup
            clear-icon="mdi-close"
            label="Bộ môn"
            dense
            hide-details
            outlined
            @change="subjectGroupChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteSubject
            v-model="subject"
            clear-icon="mdi-close"
            label="Môn học"
            outlined
            dense
            :filter="subjectFilter"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteTeacherCard
            v-model="teacher"
            item-text="name"
            clear-icon="mdi-close"
            label="Giáo viên"
            outlined
            dense
            deletable-chips
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import { get } from 'lodash'
import { mapState } from 'vuex'

export default {
  components: {
    GradeClassStudentSelect,
    AutocompleteSubjectGroup,
    AutocompleteSubject,
    AutocompleteTeacherCard
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    subject: '',
    subjectGroup: '',
    teacher: null
  }),
  methods: {
    gradeClassChange(data) {
      if (get(this.selectedGrade, 'academicLevel') !== get(data.grade, 'academicLevel')) {
        this.selectedClass = {}
        this.subjectGroup = ''
        this.subject = ''
      }
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
    },
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        teacher: get(this.teacher, 'id'),
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        subject: this.subject || undefined,
        subjectGroup: this.subjectGroup || undefined
      })
    },
    subjectGroupChanged(subjectGroup) {
      if (subjectGroup && subjectGroup !== this.subjectGroup) {
        this.subject = ''
      }
      this.subjectGroup = subjectGroup
    }
  },
  computed: {
    ...mapState('subjects', ['subjects']),
    subjectFilter() {
      return { subjectGroup: this.subjectGroup, grade: get(this.selectedGrade, 'id') }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
